<div class="dialog-header">
  <h3>{{ data.title ? data.title : "" }}</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form>
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "reason-dialog.title" | translate }}</mat-label>
        <textarea
          [formControl]="reason"
          matInput
          maxlength="100"
          rows="6"
        ></textarea>
        <mat-error *ngIf="reason.hasError('required')">
          {{
            "required-masculine"
              | translate : { label: "reason-dialog.title" | translate }
          }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>

<div class="dialog-actions">
  <button
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
    [disabled]="reason.invalid"
  >
    {{ "input-save" | translate }}
  </button>
</div>
